import Button from "./Button";
import React, { useState } from "react";
import { useReducer } from "react";
import { reducer,initialState } from "../reducers/reducers";
import '../App.css'; // Optional: If you're using an external CSS file
import EditText from "./EditText";
const EditQuantity = ({item_id,url,onCancel,onAccept}) => {
    
    const [state, dispatch] = useReducer(reducer, initialState);
    const [quantity,setQuantity] = useState(0)
    const updateCantidad = (url, id, newCantidad) => {
      return fetch(url, {
          method: 'PUT',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({
              id: id,
              cantidad: newCantidad,
          }),
      })
          .then((response) => {
              if (!response.ok) {
                  throw new Error(`HTTP error! status: ${response.status}`);
              }
              return response.json();
          })
          .then((data) => {
              if (data.success) {
                  console.log('Cantidad updated successfully:', data.message || data);
                  onAccept();
                  return data;
              } else {
                  console.error('Error updating cantidad:', data.error || 'Unknown error');
                  return data;
              }
          })
          .catch((error) => {
              console.error('Request failed:', error);
              return { success: false, error: error.message };
          });
  }
    return(
        <div className="modal-overlay">
        <div className="confirm-modal">
            Introduce la nueva cantidad
            <div className="invisible-horizontal-container">
            <input
            type="number"
            min={1}
            max={100}
            defaultValue={1}
            value={quantity || ''}
            onChange={(data) => {
                const value = data.target.value;

                // Limitar a 3 caracteres y solo números
                if (value.length <= 3 && /^\d*$/.test(value)) {
                const numericValue = parseInt(value, 10);

                // Asegurarse de que el valor esté dentro del rango permitido
                if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 100) {
                    setQuantity(numericValue)
                } else if (value === '') {
                    setQuantity(0)
                }
                }
            }}
            />
            </div>
            
            <div className="invisible-horizontal-container">
                
                <Button text="Aceptar" onClick={()=>{
                    console.log(quantity)
                  updateCantidad(url,item_id,quantity);
                  
                }} color="#7AACE3"></Button>
                <Button text="Cancelar" onClick={()=>onCancel()}></Button>
            </div>
        </div>
        </div>
    )
}
export default EditQuantity;